import React, { useEffect, useState } from "react";
import EmojiPicker from "emoji-picker-react";

import StyledIconPicker from "./styles";

const IconPicker = ({
  onPick,
  open = true,
  top,
  left,
  bottom,
  up,
  transform,
  onEmojiClick,
}) => {
  const onPickHandler = () => {
    if (onPick) {
      onPick();
    }
  };

  const onClickHandler = (e) => {
    e.stopPropagation();
  };

  return (
    <StyledIconPicker
      style={{
        top: top,
        left: left,
        bottom: bottom,
        up: up,
        transform: transform,
      }}
      onClick={onClickHandler}
    >
      <div className="icon-picker">
        <EmojiPicker open={open} onEmojiClick={onEmojiClick} />
      </div>
    </StyledIconPicker>
  );
};

export default IconPicker;
